var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
let UmblerBtn = class UmblerBtn extends Vue {
    async openLink() {
        const superlogicaAccountId = 
        // @ts-ignore
        (this.$auth.user() && this.$auth.user().superlogica_id) || '';
        const stripeAccountId = 
        // @ts-ignore
        (this.$auth.user() && this.$auth.user().customer_id) || '';
        const exceptionIds = await this.superlogicaIdListToChangeLink();
        let number = '';
        if (exceptionIds.includes(superlogicaAccountId) ||
            exceptionIds.includes(stripeAccountId)) {
            number = '13982197381';
        }
        else {
            number = '11949141302';
        }
        window.open(`https://web.whatsapp.com/send?phone=${number}`, 'popup', 'height=600,width=1000');
    }
    async superlogicaIdListToChangeLink() {
        const json = await import('@/assets/umbler_exception_superlogica_ids.json');
        return json.superlogica_ids;
    }
};
UmblerBtn = __decorate([
    Component({})
], UmblerBtn);
export default UmblerBtn;
